module.exports = __webpack_public_path__ + "img/startgame.c6efbea0.png";